define('lib/backbone/Backbone.PodioCollectionView',['require','underscore','backbone','lib/backbone/Backbone.PodioView','lib/backbone/Backbone.ChildViewContainer'],function(require) {

  var _ = require('underscore');
  var Backbone = require('backbone');
  var PodioView = require('lib/backbone/Backbone.PodioView');
  var ChildViewContainer = require('lib/backbone/Backbone.ChildViewContainer');

  return PodioView.extend({

    constructor: function(options){
      this._initChildViewStorage();

      this.bindAll('render');

      this.reversedPagination = options.reversedPagination || false;

      PodioView.prototype.constructor.apply(this, _.toArray(arguments));
    },

    _bindToCollection: function() {

      if (this.collection){
        this.collection.bind("add", this.addChildView, this);
        this.collection.bind("remove", this.removeItemView, this);
        this.collection.bind("reset", this.render, this);
      }

    },

    _initChildViewStorage: function(){
      this.children = new ChildViewContainer();
    },

    // Handle a child item added to the collection
    addChildView: function(item, collection, options){
      options = options || {};

      this.disposeEmptyView();
      var ItemView = this.getItemView(item);
      var index = this.collection.indexOf(item);
      var renderedView = this.addItemView(item, ItemView, index, options);

      if (options.prepend) {
        this.prependItem(renderedView, this.elm);
      } else {
        this.appendItem(renderedView, this.elm);
      }
    },

    render: function(){

      this.trigger("before:render");
      this.disposeEmptyView();
      this.disposeChildren();

      this.elm.empty();

      if (this.collection && this.collection.length > 0) {
        this.renderCollection();
      } else {
        this.renderEmptyView();
      }

      this.trigger("rendered");
      return this;
    },

    renderCollection: function(){
      var ItemView;
      var renderedView;

      this.collection.each(function(item, index) {
        ItemView = this.getItemView(item);
        renderedView = this.addItemView(item, ItemView, index);
        if (this.reversedPagination) {
          this.prependItem(renderedView, this.elm);
        } else {
          this.appendItem(renderedView, this.elm);
        }
      }, this);
    },

    renderEmptyView: function(){
      var EmptyView = this.getOption("emptyView");

      if (EmptyView && !this._showingEmptyView){
        this._showingEmptyView = true;
        var model = new Backbone.Model();
        this.addItemView(model, EmptyView, 0);
      }
    },

    disposeEmptyView: function(){
      if (this._showingEmptyView){
        this.disposeChildren();
        delete this._showingEmptyView;
      }
    },

    getItemView: function(item){
      var itemView = this.getOption("itemView");

      if (!itemView){
        var err = new Error("An `itemView` must be specified");
        err.name = "NoItemViewError";
        throw err;
      }

      return itemView;
    },

    addItemView: function(item, ItemView, index, options){

      // get the itemViewOptions if any were specified
      var itemViewOptions = this.getOption("itemViewOptions");
      if (_.isFunction(itemViewOptions)){
        itemViewOptions = itemViewOptions.call(this, item);
      } else {

        itemViewOptions = function() {
          return {
            eventBus: this.getOption('eventBus')
          };
        };

      }

      _.extend(itemViewOptions, options);

      // build the view
      var view = this.buildItemView(item, ItemView, itemViewOptions);

      // this view is about to be added
      this.trigger("before:item:added", view);

      // Store the child view itself so we can properly
      // remove and/or close it later
      this.children.add(view);

      // Render it and show it
      view.render();

      return view;
    },

    prependItem: function(view, elmTarget) {
      elmTarget.prepend(view.el);
      // this view was added
      this.trigger("after:item:added", view);
    },

    appendItem: function(view, elmTarget) {
      elmTarget.append(view.el);
      // this view was added
      this.trigger("after:item:added", view);
    },

    // Build an `itemView` for every model in the collection.
    buildItemView: function(item, ItemViewType, itemViewOptions){
      var options = _.extend({model: item}, itemViewOptions);
      var view = new ItemViewType(options);
      return view;
    },

    // get the child view by item it holds, and remove it
    removeItemView: function(item){
      var view = this.children.findByModel(item);
      this.removeChildView(view);
      this.checkEmpty();
    },

    refreshItemViewRendering: function(item) {
      var view = this.children.findByModel(item);

      if (view) {
        view.render();
      }
    },

    // Remove the child view and dispose it
    removeChildView: function(view){

      if (view){
        if (view.dispose){
          view.dispose();
        }
        this.children.remove(view);
      }

      this.trigger("item:removed", view);
    },

    checkEmpty: function() {
      if (!this.collection || this.collection.length === 0){
        this.showEmptyView();
      }
    },

    showEmptyView: function() {

    },

    dispose: function(){
      this.disposeChildren();
      this._super();
    },

    disposeChildren: function(){

      this.children.each(function(child){
        this.removeChildView(child);
      }, this);

      this.checkEmpty();
    }


  });

});

